<template>
    <div class="p-0 pt-3">
        <div class="chart-wrap">
            <div ref="chart" style="width: 100%; height: 170px;"></div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import {clone} from "../../utils";

    export default {
        name: "OEESummaryPanel",
        props: {
            hourlyData: {
                type: Object,
            },
            summaryData: {
                type: Object,
            }
        },
        data() {
            return {
                chartInstance: null
            };
        },
        watch: {
            hourlyData: {
                handler(newVal) {
                    if (this.chartInstance && newVal && newVal.labels) {
                        this.updateChart(newVal);
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.initChart();
        },
        beforeDestroy() {
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }
        },
        methods: {
            initChart() {
                const chartDom = this.$refs.chart;
                this.chartInstance = echarts.init(chartDom);
                if (this.hourlyData && this.hourlyData.labels) {
                    this.updateChart(this.hourlyData);
                }
            },
            updateChart(data) {
                const option = {
                    backgroundColor: 'transparent',
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } },
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        borderColor: '#333',
                        borderWidth: 1,
                        textStyle: { color: '#fff' },
                        formatter: function (params) {
                            let tooltip = 'Hour: ' + params[0].name + ':00<br />';
                            params.forEach(param => {
                                tooltip += param.marker + ' ' + param.seriesName + ': ' + parseFloat(param.value).toFixed(2) + ' %<br />';
                            });
                            return tooltip;
                        }
                    },
                    legend: {
                        data: ['OEE', 'Availability', 'Performance', 'Quality'],
                        textStyle: { color: '#333' },
                        bottom: 0,
                        padding: [0, 0, 10, 0]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '15%',
                        top: '5%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: data.labels,
                        axisLabel: { color: '#000' },
                        axisLine: { lineStyle: { color: '#CCCCCC' } },
                        splitLine: {
                            show: true,
                            lineStyle: { color: '#CCCCCC', type: 'dashed' }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: { color: '#000', formatter: '{value} %' },
                        axisLine: { show: false },
                        splitLine: { lineStyle: { color: '#DDDDDD', type: 'dashed' } },
                        max: 100,
                        min: 0
                    },
                    series: [
                        this.createSeries('OEE', data.oee, '#605e5e', 3),
                        this.createSeries('Availability', data.availability, '#03A9F4', 2),
                        this.createSeries('Performance', data.performance, '#8BC34A', 2),
                        this.createSeries('Quality', data.quality, '#FF9800', 2)
                    ]
                };
                this.chartInstance.setOption(option);
            },
            createSeries(name, data, color, width) {
                return {
                    name: name,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 6,
                    data: data,
                    itemStyle: { color: color },
                    lineStyle: { width: width || 2 },
                    animationDuration: 2000,
                    animationEasing: 'cubicOut'
                };
            }
        }
    }
</script>
